import { constants } from "@/utils/constants";
import { paginateTable } from "@/interfaces/Additional.interfaces";

export function linkedJobIdFromQuery(jobId: unknown): string {
  if (jobId == null) return "";
  const value = Array.isArray(jobId) ? jobId[0] : jobId;
  return String(value || "").trim();
}

export function jobSearchColumnsForLinkedId(linkedJobId: string): string[] | undefined {
  if (!linkedJobId) return undefined;
  return constants.enabledColumns.jobTableSearch.map((col: string) =>
    col.includes(".") ? col : `j.${col}`
  );
}

export function jobPrefetchPaginationPayload(
  tablename: string,
  jobId: unknown
): paginateTable {
  const linkedJobId =
    tablename === "Job" ? linkedJobIdFromQuery(jobId) : "";
  return {
    tableName: tablename,
    limit: 15,
    page: 1,
    columnNames:
      constants.enabledColumns[tablename.toLowerCase() + "Table"],
    ...(linkedJobId && {
      search: linkedJobId,
      searchColumns: jobSearchColumnsForLinkedId(linkedJobId)
    })
  } as paginateTable;
}

export type LinkedJobSearchVm = {
  $route?: { query?: { jobId?: unknown } };
  tableSearch: string;
  totalItems: number;
  options?: { page?: number };
  getDataFromApi: () => void;
  $nextTick: (cb: () => void) => void | Promise<void>;
};

export function syncJobSearchFromRoute(vm: LinkedJobSearchVm): void {
  const linkedJobId = linkedJobIdFromQuery(vm.$route?.query?.jobId);
  if (!linkedJobId) return;
  vm.tableSearch = linkedJobId;
  vm.$nextTick(() => {
    vm.totalItems = 0;
    if (vm.options) vm.options.page = 1;
    vm.getDataFromApi();
  });
}
